import { Button, Modal, Row, Col, Icon } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getHeaderSummary, onLoadHeader } from './../../../../actions/headerAction';
import { onSubmit, update } from './../../../../actions/ordersAction';
import { onOk } from './../../../../actions/syncAction';
import { convertDateToUTC } from './../../../../services/dst';
import iconAmazon from './../../../../resources/imgs/channel/amazon.png';
import iconRakuten from './../../../../resources/imgs/channel/rakuten.png';
import './styles.css';

class SyncResult extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isActiveErrorAmz: false,
            isActiveErrorRkt: false,
            isActiveErrorOne: false,
        }
    }

    toggleIsActiveErrorAmz(e) {
        e.preventDefault();
        let isActiveErrorAmz = this.state.isActiveErrorAmz;
        this.setState({
            isActiveErrorAmz: !isActiveErrorAmz
        })
    }

    toggleIsActiveErrorRkt(e) {
        e.preventDefault();
        let isActiveErrorRkt = this.state.isActiveErrorRkt;
        this.setState({
            isActiveErrorRkt: !isActiveErrorRkt
        })
    }

    toggleIsActiveErrorOne(e) {
        e.preventDefault();
        let isActiveErrorOne = this.state.isActiveErrorOne;
        this.setState({
            isActiveErrorOne: !isActiveErrorOne
        })
    }

    resetIsActiveError() {
        this.setState({
            isActiveErrorAmz: false,
            isActiveErrorRkt: false,
            isActiveErrorOne: false,
        });
    }

    render() {
        const styleHidden = { display: 'none' };
        const styleShow = { display: 'block' };
        let result_one = null;
        let result_amazon = null;
        let result_rakuten = null;
        if (this.props.sync_result) {
            if (this.props.sync_result.ImportApiResultList.length === 1) {
                result_one = this.props.sync_result.ImportApiResultList[0];
            } else {
                result_amazon = this.props.sync_result.ImportApiResultList[0];
                result_rakuten = this.props.sync_result.ImportApiResultList[1];
            }
        }

        return (
            <div id="import-order">
                <Modal
                    className="modal-result-import-order"
                    width={820}
                    title="Import successful."
                    visible={this.props.sync_success_visible}
                    closable={false}
                    footer={[
                        <Button key="ok_modal_sync_success" type="primary"
                            onClick={() => {
                                this.setState({
                                    isActiveErrorAmz: false,
                                    isActiveErrorRkt: false,
                                    isActiveErrorOne: false,
                                });
                                this.props.onOk()
                                this.props.onSubmit({ ...this.props.getOrderParams, Page: 1, OrderBy: "OrderDT" })
                            }}>
                            OK
                        </Button>,
                    ]}
                >
                    {result_amazon ?
                        <div className="import-amazon">
                            <Row gutter={6}>
                                <Col span={6}>
                                    <img className="icon-image" src={iconAmazon} />
                                </Col>
                                <Col span={6}>
                                    {result_amazon ? <p>{result_amazon.ImportedCount} orders imported</p> : ''}
                                </Col>
                                <Col span={6}>
                                    {result_amazon ? <p>{result_amazon.ErrorCount} orders with errors</p> : ''}
                                </Col>
                                <Col span={6}>
                                    {
                                        (result_amazon && result_amazon.NotImportedCount) ?
                                            <a onClick={e => this.toggleIsActiveErrorAmz(e)} className="error-not-import">
                                                {result_amazon ? <p>{result_amazon.NotImportedCount} orders Not-Imported{this.state.isActiveErrorAmz ? <Icon type="down" className="icon-result" /> : <Icon type="right" className="icon-result" />}</p> : ''}
                                            </a>
                                            :
                                            <p>0 orders Not-Imported</p>
                                    }
                                </Col>
                            </Row>
                            {(result_amazon && result_amazon.NotImportedCount) ?
                                <div className="not-importID not-importID-amz" style={this.state.isActiveErrorAmz ? styleShow : styleHidden}>
                                    <h3 className="title-not-import">Not-Imported Orders ID</h3>
                                    <Button onClick={e => this.toggleIsActiveErrorAmz(e)} type="link" className="close-box-error-import"><Icon type="close" /></Button>
                                    <div className="list-id-not-import">
                                        <p>
                                            {result_amazon.NotImportedList.join(", ")}
                                        </p>
                                    </div>
                                </div>
                                : ''}
                        </div>
                        : ''}
                    {result_rakuten ?
                        <div className="import-rakuten">
                            <Row gutter={6}>
                                <Col span={6}>
                                    <img className="icon-image-rakuten" src={iconRakuten} />
                                </Col>
                                <Col span={6}>
                                    {result_rakuten ? <p>{result_rakuten.ImportedCount} orders imported</p> : ''}
                                </Col>
                                <Col span={6}>
                                    {result_rakuten ? <p>{result_rakuten.ErrorCount} orders with errors</p> : ''}
                                </Col>
                                <Col span={6}>
                                    {
                                        (result_rakuten && result_rakuten.NotImportedCount) ?
                                            <a onClick={e => this.toggleIsActiveErrorRkt(e)} className="error-not-import">
                                                {result_rakuten ? <p>{result_rakuten.NotImportedCount} orders Not-Imported{this.state.isActiveErrorRkt ? <Icon type="down" className="icon-result" /> : <Icon type="right" className="icon-result" />}</p> : ''}
                                            </a>
                                            :
                                            <p>0 orders Not-Imported</p>
                                    }
                                </Col>
                            </Row>
                            {(result_rakuten && result_rakuten.NotImportedCount) ?
                                <div className="not-importID not-importID-rkt" style={this.state.isActiveErrorRkt ? styleShow : styleHidden}>
                                    <h3 className="title-not-import">Not-Imported Orders ID</h3>
                                    <Button onClick={e => this.toggleIsActiveErrorRkt(e)} type="link" className="close-box-error-import"><Icon type="close" /></Button>
                                    <div className="list-id-not-import">
                                        <p>
                                            {result_rakuten.NotImportedList.join(", ")}
                                        </p>
                                    </div>
                                </div>
                                : ''}
                        </div>
                        : ''}
                    {result_one ?
                        <div className="import-rakuten">
                            <Row gutter={6}>
                                <Col span={6}>
                                    {result_one.ChannelName === "Amazon.co.jp" ? <img className="icon-image" src={iconAmazon} /> : ''}
                                    {result_one.ChannelName === "Rakuten" ? <img className="icon-image-rakuten" src={iconRakuten} /> : ''}
                                </Col>
                                <Col span={6}>
                                    {result_one ? <p>{result_one.ImportedCount} orders imported</p> : ''}
                                </Col>
                                <Col span={6}>
                                    {result_one ? <p>{result_one.ErrorCount} orders with errors</p> : ''}
                                </Col>
                                <Col span={6}>
                                    {
                                        (result_one && result_one.NotImportedCount) ?
                                            <a onClick={e => this.toggleIsActiveErrorOne(e)} className="error-not-import">
                                                {result_one ? <p>{result_one.NotImportedCount} orders Not-Imported{this.state.isActiveErrorOne ? <Icon type="down" className="icon-result" /> : <Icon type="right" className="icon-result" />}</p> : ''}
                                            </a>
                                            :
                                            <p>0 orders Not-Imported</p>
                                    }
                                </Col>
                            </Row>
                            {(result_one && result_one.NotImportedCount) ?
                                <div className="not-importID not-importID-rkt" style={this.state.isActiveErrorOne ? styleShow : styleHidden}>
                                    <h3 className="title-not-import">Not-Imported Orders ID</h3>
                                    <Button onClick={e => this.toggleIsActiveErrorOne(e)} type="link" className="close-box-error-import"><Icon type="close" /></Button>
                                    <div className="list-id-not-import">
                                        <p>
                                            {result_one.NotImportedList.join(", ")}
                                        </p>
                                    </div>
                                </div>
                                : ''}
                        </div>
                        : ''}
                    {this.props.code == 10007 ?
                        <div className="import-background">
                            <p>
                                We are processing your order import, you will receive the notification email when the process is done.
                            </p>
                        </div>
                    : ''}
                </Modal>
                <Modal
                    title="Sync process is being performed by another user."
                    visible={this.props.sync_failure_visible}
                    closable={false}
                    footer={[
                        <Button key="ok_modal_sync_success" type="primary" onClick={this.props.onOk}>
                            OK
                        </Button>,
                    ]}
                >
                </Modal>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        sync_success_visible: state.syncReducer.sync_success_visible,
        sync_failure_visible: state.syncReducer.sync_failure_visible,
        sync_result: state.syncReducer.sync_result,
        PageSize: state.ordersReducer.offset,
        code: state.syncReducer.code,
        getOrderParams: {
            Status: state.ordersReducer.input_filter.status_list,
            FulfillOption: state.ordersReducer.input_filter.fulfill_option,
            Type: state.ordersReducer.input_filter.type_list,
            OrderDateFrom: convertDateToUTC(new Date(state.ordersReducer.input_filter.from + ' 00:00:00')),
            OrderDateTo: convertDateToUTC(new Date(state.ordersReducer.input_filter.to + ' 23:59:59')),
            OrderBy: state.ordersReducer.orderBy,
            IsDesc: state.ordersReducer.isDesc,
            PageSize: state.ordersReducer.offset,
            Page: state.ordersReducer.current_page,
            ChannelOrderID: state.ordersReducer.input_filter.channel_order_no,
            ChannelID: state.ordersReducer.input_filter.channel,
            SelectedIds: state.ordersReducer.listIdCheckedOrders,
        },
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onOk: () => {
            dispatch(onOk())
        },
        onSubmit: payload => {
            dispatch(onSubmit(payload))
        },
        update: (payload) => {
            dispatch(update(payload))
        },
        onLoadHeader: payload => {
            dispatch(onLoadHeader(payload))
        },
        getHeaderSummary: () => {
            dispatch(getHeaderSummary())
        },
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SyncResult)



// WEBPACK FOOTER //
// ./src/containers/orders/components/sync-result/index.js